import type { NavigateFunction } from 'react-router-dom';

/** 与侧栏 isClawMode 一致：仅 mario 壳上的 /skills 与 /skills/*（不含 /skills-official） */
export function isMarioSkillsShellPathname(pathname: string): boolean {
  return pathname === '/skills' || pathname.startsWith('/skills/');
}

function normalizeSkillsSyncPathname(rawPath: string): string | null {
  let pathname = String(rawPath ?? '');
  if (pathname.startsWith('/skills-official')) {
    pathname =
      pathname === '/skills-official'
        ? '/skills'
        : `/skills${pathname.slice('/skills-official'.length)}`;
  }
  if (pathname !== '/skills' && !pathname.startsWith('/skills/')) {
    return null;
  }
  return pathname;
}

/**
 * skillshub iframe → 父窗口：同步地址栏（mario-skills-sync）与跳转 Claw 等（mario-navigate）
 */
export function createMarioSkillsIframeMessageHandler(
  navigate: NavigateFunction,
): (event: MessageEvent) => void {
  return (event: MessageEvent) => {
    if (event.origin !== window.location.origin) {
      return;
    }
    if (event.data?.type === 'mario-skills-sync') {
      const { path: rawPath, search = '', hash = '' } = event.data as {
        type: string;
        path?: string;
        search?: string;
        hash?: string;
      };
      const pathname = normalizeSkillsSyncPathname(String(rawPath ?? ''));
      if (!pathname) {
        return;
      }
      if (
        window.location.pathname === pathname &&
        window.location.search === search &&
        window.location.hash === hash
      ) {
        return;
      }
      navigate({ pathname, search, hash }, { replace: true });
      return;
    }
    if (event.data?.type === 'mario-navigate') {
      const { path, search } = event.data as { type: string; path: string; search?: string };
      const searchParams = new URLSearchParams(search ?? '');
      const initialPrompt = searchParams.get('initialPrompt');
      navigate(path, initialPrompt ? { state: { initialPrompt } } : undefined);
    }
  };
}
